var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pms-wrap" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pms-tabs" },
        _vm._l(_vm.tabs, function(tab) {
          return _c(
            "button",
            {
              key: tab.key,
              staticClass: "pms-tab",
              class: { "pms-tab--active": _vm.activeTab === tab.key },
              on: {
                click: function($event) {
                  _vm.activeTab = tab.key
                }
              }
            },
            [
              _c("span", { staticClass: "dashicons", class: tab.icon }),
              _vm._v("\n      " + _vm._s(tab.label) + "\n      "),
              _vm.isGatewayEnabled(tab.key)
                ? _c("span", { staticClass: "pms-tab__dot" })
                : _vm._e()
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "pms-loading" },
            [_c("el-skeleton", { attrs: { rows: 6, animated: "" } })],
            1
          )
        : [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab === "general",
                    expression: "activeTab === 'general'"
                  }
                ],
                staticClass: "pms-section"
              },
              [
                _c("div", { staticClass: "pms-card" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "pms-card__body" }, [
                    _c(
                      "div",
                      { staticClass: "pms-field" },
                      [
                        _c("label", { staticClass: "pms-label" }, [
                          _vm._v("Default Currency")
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "200px" },
                            model: {
                              value: _vm.settings.general.currency,
                              callback: function($$v) {
                                _vm.$set(_vm.settings.general, "currency", $$v)
                              },
                              expression: "settings.general.currency"
                            }
                          },
                          _vm._l(_vm.currencies, function(c) {
                            return _c("el-option", {
                              key: c.code,
                              attrs: {
                                label: c.name + " (" + c.code + ")",
                                value: c.code
                              }
                            })
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "pms-hint" }, [
                          _vm._v("Currency used for payment transactions.")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pms-field" },
                      [
                        _c("label", { staticClass: "pms-label" }, [
                          _vm._v("Success Redirect URL")
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          attrs: {
                            placeholder: "https://yoursite.com/thank-you"
                          },
                          model: {
                            value: _vm.settings.general.success_url,
                            callback: function($$v) {
                              _vm.$set(_vm.settings.general, "success_url", $$v)
                            },
                            expression: "settings.general.success_url"
                          }
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "pms-hint" }, [
                          _vm._v(
                            "Redirect here after a successful payment. Leave empty to stay on page."
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pms-field" },
                      [
                        _c("label", { staticClass: "pms-label" }, [
                          _vm._v("Cancel / Failure Redirect URL")
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          attrs: {
                            placeholder: "https://yoursite.com/payment-failed"
                          },
                          model: {
                            value: _vm.settings.general.cancel_url,
                            callback: function($$v) {
                              _vm.$set(_vm.settings.general, "cancel_url", $$v)
                            },
                            expression: "settings.general.cancel_url"
                          }
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "pms-hint" }, [
                          _vm._v(
                            "Redirect here when a payment is cancelled or fails."
                          )
                        ])
                      ],
                      1
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab === "stripe",
                    expression: "activeTab === 'stripe'"
                  }
                ],
                staticClass: "pms-section"
              },
              [
                _c("div", { staticClass: "pms-card" }, [
                  _c(
                    "div",
                    { staticClass: "pms-card__head" },
                    [
                      _c("div", { staticClass: "pms-card__head-left" }, [
                        _c(
                          "span",
                          { staticClass: "pms-gw-badge pms-gw-badge--stripe" },
                          [_vm._v("Stripe")]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "pms-status",
                            class: _vm.settings.stripe.enabled
                              ? "pms-status--on"
                              : "pms-status--off"
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.settings.stripe.enabled
                                    ? "Enabled"
                                    : "Disabled"
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("el-switch", {
                        model: {
                          value: _vm.settings.stripe.enabled,
                          callback: function($$v) {
                            _vm.$set(_vm.settings.stripe, "enabled", $$v)
                          },
                          expression: "settings.stripe.enabled"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pms-card__body" },
                    [
                      _c("div", { staticClass: "pms-field" }, [
                        _c("label", { staticClass: "pms-label" }, [
                          _vm._v("Mode")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pms-mode-toggle" }, [
                          _c(
                            "button",
                            {
                              staticClass: "pms-mode-btn",
                              class: {
                                "pms-mode-btn--active":
                                  _vm.settings.stripe.test_mode
                              },
                              on: {
                                click: function($event) {
                                  _vm.settings.stripe.test_mode = true
                                }
                              }
                            },
                            [_vm._v("Test")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "pms-mode-btn",
                              class: {
                                "pms-mode-btn--active": !_vm.settings.stripe
                                  .test_mode
                              },
                              on: {
                                click: function($event) {
                                  _vm.settings.stripe.test_mode = false
                                }
                              }
                            },
                            [_vm._v("Live")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.settings.stripe.test_mode
                        ? [
                            _c(
                              "div",
                              { staticClass: "pms-field" },
                              [
                                _c("label", { staticClass: "pms-label" }, [
                                  _vm._v("Test Publishable Key")
                                ]),
                                _vm._v(" "),
                                _c("el-input", {
                                  attrs: { placeholder: "pk_test_..." },
                                  model: {
                                    value:
                                      _vm.settings.stripe.test_publishable_key,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.settings.stripe,
                                        "test_publishable_key",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "settings.stripe.test_publishable_key"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "pms-field" },
                              [
                                _c("label", { staticClass: "pms-label" }, [
                                  _vm._v("Test Secret Key")
                                ]),
                                _vm._v(" "),
                                _c("el-input", {
                                  attrs: {
                                    type: "password",
                                    "show-password": "",
                                    placeholder: "sk_test_..."
                                  },
                                  model: {
                                    value: _vm.settings.stripe.test_secret_key,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.settings.stripe,
                                        "test_secret_key",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "settings.stripe.test_secret_key"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : [
                            _c(
                              "div",
                              { staticClass: "pms-field" },
                              [
                                _c("label", { staticClass: "pms-label" }, [
                                  _vm._v("Live Publishable Key")
                                ]),
                                _vm._v(" "),
                                _c("el-input", {
                                  attrs: { placeholder: "pk_live_..." },
                                  model: {
                                    value:
                                      _vm.settings.stripe.live_publishable_key,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.settings.stripe,
                                        "live_publishable_key",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "settings.stripe.live_publishable_key"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "pms-field" },
                              [
                                _c("label", { staticClass: "pms-label" }, [
                                  _vm._v("Live Secret Key")
                                ]),
                                _vm._v(" "),
                                _c("el-input", {
                                  attrs: {
                                    type: "password",
                                    "show-password": "",
                                    placeholder: "sk_live_..."
                                  },
                                  model: {
                                    value: _vm.settings.stripe.live_secret_key,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.settings.stripe,
                                        "live_secret_key",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "settings.stripe.live_secret_key"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pms-field" },
                        [
                          _c("label", { staticClass: "pms-label" }, [
                            _vm._v("Webhook Secret")
                          ]),
                          _vm._v(" "),
                          _c("el-input", {
                            attrs: {
                              type: "password",
                              "show-password": "",
                              placeholder: "whsec_..."
                            },
                            model: {
                              value: _vm.settings.stripe.webhook_secret,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings.stripe,
                                  "webhook_secret",
                                  $$v
                                )
                              },
                              expression: "settings.stripe.webhook_secret"
                            }
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "pms-hint" }, [
                            _vm._v(
                              "\n              Add this endpoint URL to your Stripe dashboard:\n              "
                            ),
                            _c("code", { staticClass: "pms-code" }, [
                              _vm._v(
                                _vm._s(_vm.ajaxUrl) +
                                  "?action=contactum_stripe_webhook"
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    2
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab === "paypal",
                    expression: "activeTab === 'paypal'"
                  }
                ],
                staticClass: "pms-section"
              },
              [
                _c("div", { staticClass: "pms-card" }, [
                  _c(
                    "div",
                    { staticClass: "pms-card__head" },
                    [
                      _c("div", { staticClass: "pms-card__head-left" }, [
                        _c(
                          "span",
                          { staticClass: "pms-gw-badge pms-gw-badge--paypal" },
                          [_vm._v("PayPal")]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "pms-status",
                            class: _vm.settings.paypal.enabled
                              ? "pms-status--on"
                              : "pms-status--off"
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.settings.paypal.enabled
                                    ? "Enabled"
                                    : "Disabled"
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("el-switch", {
                        model: {
                          value: _vm.settings.paypal.enabled,
                          callback: function($$v) {
                            _vm.$set(_vm.settings.paypal, "enabled", $$v)
                          },
                          expression: "settings.paypal.enabled"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pms-card__body" },
                    [
                      _c("div", { staticClass: "pms-field" }, [
                        _c("label", { staticClass: "pms-label" }, [
                          _vm._v("Mode")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pms-mode-toggle" }, [
                          _c(
                            "button",
                            {
                              staticClass: "pms-mode-btn",
                              class: {
                                "pms-mode-btn--active":
                                  _vm.settings.paypal.test_mode
                              },
                              on: {
                                click: function($event) {
                                  _vm.settings.paypal.test_mode = true
                                }
                              }
                            },
                            [_vm._v("Sandbox")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "pms-mode-btn",
                              class: {
                                "pms-mode-btn--active": !_vm.settings.paypal
                                  .test_mode
                              },
                              on: {
                                click: function($event) {
                                  _vm.settings.paypal.test_mode = false
                                }
                              }
                            },
                            [_vm._v("Live")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.settings.paypal.test_mode
                        ? [
                            _c(
                              "div",
                              { staticClass: "pms-field" },
                              [
                                _c("label", { staticClass: "pms-label" }, [
                                  _vm._v("Sandbox Client ID")
                                ]),
                                _vm._v(" "),
                                _c("el-input", {
                                  attrs: { placeholder: "Sandbox Client ID" },
                                  model: {
                                    value:
                                      _vm.settings.paypal.sandbox_client_id,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.settings.paypal,
                                        "sandbox_client_id",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "settings.paypal.sandbox_client_id"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "pms-field" },
                              [
                                _c("label", { staticClass: "pms-label" }, [
                                  _vm._v("Sandbox Client Secret")
                                ]),
                                _vm._v(" "),
                                _c("el-input", {
                                  attrs: {
                                    type: "password",
                                    "show-password": "",
                                    placeholder: "Sandbox Client Secret"
                                  },
                                  model: {
                                    value:
                                      _vm.settings.paypal.sandbox_client_secret,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.settings.paypal,
                                        "sandbox_client_secret",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "settings.paypal.sandbox_client_secret"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : [
                            _c(
                              "div",
                              { staticClass: "pms-field" },
                              [
                                _c("label", { staticClass: "pms-label" }, [
                                  _vm._v("Live Client ID")
                                ]),
                                _vm._v(" "),
                                _c("el-input", {
                                  attrs: { placeholder: "Live Client ID" },
                                  model: {
                                    value: _vm.settings.paypal.live_client_id,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.settings.paypal,
                                        "live_client_id",
                                        $$v
                                      )
                                    },
                                    expression: "settings.paypal.live_client_id"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "pms-field" },
                              [
                                _c("label", { staticClass: "pms-label" }, [
                                  _vm._v("Live Client Secret")
                                ]),
                                _vm._v(" "),
                                _c("el-input", {
                                  attrs: {
                                    type: "password",
                                    "show-password": "",
                                    placeholder: "Live Client Secret"
                                  },
                                  model: {
                                    value:
                                      _vm.settings.paypal.live_client_secret,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.settings.paypal,
                                        "live_client_secret",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "settings.paypal.live_client_secret"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                    ],
                    2
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab === "razorpay",
                    expression: "activeTab === 'razorpay'"
                  }
                ],
                staticClass: "pms-section"
              },
              [
                _c("div", { staticClass: "pms-card" }, [
                  _c(
                    "div",
                    { staticClass: "pms-card__head" },
                    [
                      _c("div", { staticClass: "pms-card__head-left" }, [
                        _c(
                          "span",
                          {
                            staticClass: "pms-gw-badge pms-gw-badge--razorpay"
                          },
                          [_vm._v("Razorpay")]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "pms-status",
                            class: _vm.settings.razorpay.enabled
                              ? "pms-status--on"
                              : "pms-status--off"
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.settings.razorpay.enabled
                                    ? "Enabled"
                                    : "Disabled"
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("el-switch", {
                        model: {
                          value: _vm.settings.razorpay.enabled,
                          callback: function($$v) {
                            _vm.$set(_vm.settings.razorpay, "enabled", $$v)
                          },
                          expression: "settings.razorpay.enabled"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pms-card__body" },
                    [
                      _c("div", { staticClass: "pms-field" }, [
                        _c("label", { staticClass: "pms-label" }, [
                          _vm._v("Mode")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pms-mode-toggle" }, [
                          _c(
                            "button",
                            {
                              staticClass: "pms-mode-btn",
                              class: {
                                "pms-mode-btn--active":
                                  _vm.settings.razorpay.test_mode
                              },
                              on: {
                                click: function($event) {
                                  _vm.settings.razorpay.test_mode = true
                                }
                              }
                            },
                            [_vm._v("Test")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "pms-mode-btn",
                              class: {
                                "pms-mode-btn--active": !_vm.settings.razorpay
                                  .test_mode
                              },
                              on: {
                                click: function($event) {
                                  _vm.settings.razorpay.test_mode = false
                                }
                              }
                            },
                            [_vm._v("Live")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.settings.razorpay.test_mode
                        ? [
                            _c(
                              "div",
                              { staticClass: "pms-field" },
                              [
                                _c("label", { staticClass: "pms-label" }, [
                                  _vm._v("Test Key ID")
                                ]),
                                _vm._v(" "),
                                _c("el-input", {
                                  attrs: { placeholder: "rzp_test_..." },
                                  model: {
                                    value: _vm.settings.razorpay.test_key_id,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.settings.razorpay,
                                        "test_key_id",
                                        $$v
                                      )
                                    },
                                    expression: "settings.razorpay.test_key_id"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "pms-field" },
                              [
                                _c("label", { staticClass: "pms-label" }, [
                                  _vm._v("Test Key Secret")
                                ]),
                                _vm._v(" "),
                                _c("el-input", {
                                  attrs: {
                                    type: "password",
                                    "show-password": "",
                                    placeholder: "Test Key Secret"
                                  },
                                  model: {
                                    value:
                                      _vm.settings.razorpay.test_key_secret,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.settings.razorpay,
                                        "test_key_secret",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "settings.razorpay.test_key_secret"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : [
                            _c(
                              "div",
                              { staticClass: "pms-field" },
                              [
                                _c("label", { staticClass: "pms-label" }, [
                                  _vm._v("Live Key ID")
                                ]),
                                _vm._v(" "),
                                _c("el-input", {
                                  attrs: { placeholder: "rzp_live_..." },
                                  model: {
                                    value: _vm.settings.razorpay.live_key_id,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.settings.razorpay,
                                        "live_key_id",
                                        $$v
                                      )
                                    },
                                    expression: "settings.razorpay.live_key_id"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "pms-field" },
                              [
                                _c("label", { staticClass: "pms-label" }, [
                                  _vm._v("Live Key Secret")
                                ]),
                                _vm._v(" "),
                                _c("el-input", {
                                  attrs: {
                                    type: "password",
                                    "show-password": "",
                                    placeholder: "Live Key Secret"
                                  },
                                  model: {
                                    value:
                                      _vm.settings.razorpay.live_key_secret,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.settings.razorpay,
                                        "live_key_secret",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "settings.razorpay.live_key_secret"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                    ],
                    2
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab === "mollie",
                    expression: "activeTab === 'mollie'"
                  }
                ],
                staticClass: "pms-section"
              },
              [
                _c("div", { staticClass: "pms-card" }, [
                  _c(
                    "div",
                    { staticClass: "pms-card__head" },
                    [
                      _c("div", { staticClass: "pms-card__head-left" }, [
                        _c(
                          "span",
                          { staticClass: "pms-gw-badge pms-gw-badge--mollie" },
                          [_vm._v("Mollie")]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "pms-status",
                            class: _vm.settings.mollie.enabled
                              ? "pms-status--on"
                              : "pms-status--off"
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.settings.mollie.enabled
                                    ? "Enabled"
                                    : "Disabled"
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("el-switch", {
                        model: {
                          value: _vm.settings.mollie.enabled,
                          callback: function($$v) {
                            _vm.$set(_vm.settings.mollie, "enabled", $$v)
                          },
                          expression: "settings.mollie.enabled"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pms-card__body" },
                    [
                      _c("div", { staticClass: "pms-field" }, [
                        _c("label", { staticClass: "pms-label" }, [
                          _vm._v("Mode")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pms-mode-toggle" }, [
                          _c(
                            "button",
                            {
                              staticClass: "pms-mode-btn",
                              class: {
                                "pms-mode-btn--active":
                                  _vm.settings.mollie.test_mode
                              },
                              on: {
                                click: function($event) {
                                  _vm.settings.mollie.test_mode = true
                                }
                              }
                            },
                            [_vm._v("Test")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "pms-mode-btn",
                              class: {
                                "pms-mode-btn--active": !_vm.settings.mollie
                                  .test_mode
                              },
                              on: {
                                click: function($event) {
                                  _vm.settings.mollie.test_mode = false
                                }
                              }
                            },
                            [_vm._v("Live")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.settings.mollie.test_mode
                        ? [
                            _c(
                              "div",
                              { staticClass: "pms-field" },
                              [
                                _c("label", { staticClass: "pms-label" }, [
                                  _vm._v("Test API Key")
                                ]),
                                _vm._v(" "),
                                _c("el-input", {
                                  attrs: {
                                    type: "password",
                                    "show-password": "",
                                    placeholder: "test_..."
                                  },
                                  model: {
                                    value: _vm.settings.mollie.test_api_key,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.settings.mollie,
                                        "test_api_key",
                                        $$v
                                      )
                                    },
                                    expression: "settings.mollie.test_api_key"
                                  }
                                }),
                                _vm._v(" "),
                                _c("p", { staticClass: "pms-hint" }, [
                                  _vm._v(
                                    "Found in your Mollie dashboard under Developers → API keys."
                                  )
                                ])
                              ],
                              1
                            )
                          ]
                        : [
                            _c(
                              "div",
                              { staticClass: "pms-field" },
                              [
                                _c("label", { staticClass: "pms-label" }, [
                                  _vm._v("Live API Key")
                                ]),
                                _vm._v(" "),
                                _c("el-input", {
                                  attrs: {
                                    type: "password",
                                    "show-password": "",
                                    placeholder: "live_..."
                                  },
                                  model: {
                                    value: _vm.settings.mollie.live_api_key,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.settings.mollie,
                                        "live_api_key",
                                        $$v
                                      )
                                    },
                                    expression: "settings.mollie.live_api_key"
                                  }
                                }),
                                _vm._v(" "),
                                _c("p", { staticClass: "pms-hint" }, [
                                  _vm._v(
                                    "Found in your Mollie dashboard under Developers → API keys."
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                      _vm._v(" "),
                      _c("div", { staticClass: "pms-field" }, [
                        _c("label", { staticClass: "pms-label" }, [
                          _vm._v("Webhook URL")
                        ]),
                        _vm._v(" "),
                        _c("code", { staticClass: "pms-code" }, [
                          _vm._v(
                            _vm._s(_vm.ajaxUrl) +
                              "?action=contactum_mollie_webhook"
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "pms-hint" }, [
                          _vm._v(
                            "Mollie calls this URL automatically — no manual configuration needed in your Mollie dashboard."
                          )
                        ])
                      ])
                    ],
                    2
                  )
                ])
              ]
            )
          ],
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pms-footer" },
        [
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                loading: _vm.saving,
                icon: "el-icon-check"
              },
              on: { click: _vm.saveSettings }
            },
            [_vm._v("\n      Save Settings\n    ")]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pms-header" }, [
      _c("div", { staticClass: "pms-header__left" }, [
        _c("div", { staticClass: "pms-header__icon" }, [
          _c("span", { staticClass: "dashicons dashicons-money-alt" })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("h2", { staticClass: "pms-header__title" }, [
            _vm._v("Payment Gateways")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "pms-header__sub" }, [
            _vm._v("Configure payment methods for your forms")
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pms-card__head" }, [
      _c("h3", { staticClass: "pms-card__title" }, [_vm._v("General Settings")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }